import { useEffect, useState } from "react";
import { decode } from "jwt-decode";

// Function to decode JWT token
const parseJwt = (token) => {
  if (!token) return null;
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
};

// Custom hook to fetch subscription status
const subscriptionStatus = () => {
  const [subscriptionType, setSubscriptionType] = useState(null); // Store subscription type (free, premium, enterprise)

  useEffect(() => {
    const token = localStorage.getItem("token");
    console.log("Token:", token); // Log the token to check if it's present

    if (token) {
      try {
        const decoded = parseJwt(token);
        console.log("Decoded JWT:", decoded); // Log the decoded JWT to check its content

        const subscription_type = decoded.subscription_type;
        const expiresAt = new Date(decoded.subscription_expires_at);

        console.log("Subscription subscription_type:", subscription_type); // Log the subscription type
        console.log("Subscription Expiry Date:", expiresAt); // Log the expiry date

        // Set the subscription type only if the subscription is still valid
        if (expiresAt > new Date()) {
          setSubscriptionType(subscription_type); // Store the subscription type
        } else {
          setSubscriptionType("free"); // If expired, set it to null
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        setSubscriptionType("free"); // Handle error case
      }
    } else {
      console.log("No token found in localStorage.");
      setSubscriptionType("free"); // No token found
    }
  }, []);

  return subscriptionType; // Return the subscription type (free, premium, enterprise, or null)
};

export default subscriptionStatus;
